import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useBillingPlanType } from '@app/common/src/hooks/useBillingPlanType/useBillingPlanType'
import { useF2UpsellFeatureConfig } from './useF2UpsellFeatureConfig'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

export const useF2UpsellFeature = (flag: string): { isReady: boolean; isAvailable: boolean } => {
  const [featureFlag] = useFlowFeature(flag)
  const { isAuthenticated, isAuthChecked } = useAuthState()
  const billingPlanType = useBillingPlanType()
  const { isDisabled } = useF2UpsellFeatureConfig(flag)
  const isReady = isAuthenticated && isAuthChecked && Boolean(billingPlanType)
  return {
    isReady,
    isAvailable: Boolean(
      isReady &&
        featureFlag &&
        billingPlanType &&
        ![PlanType.ENTERPRISE].includes(billingPlanType) &&
        !isDisabled
    )
  }
}
